<template>
  <div class="global" style="color:#00f2ea" ref="skill"></div>
</template>

<script>
import TagCloud from "TagCloud";

export default {
  name: "tag-cloud",
  mounted() {
    const container = this.$refs.skill;
    let radius = 350;

    const updateRadius = () => {
      const x = window.matchMedia("(max-width: 600px)");
      if (x.matches) {
        radius = 190;
      } else {
        radius = 350;
      }
    };

    updateRadius(); // Set initial radius based on window width
    window.addEventListener("resize", updateRadius); // Add event listener to update radius on window resize

    const texts = [
  // Language
  "JavaScript",
  "Dart",
  "PHP",
  "Python",

  // Front-End
  "Flutter",
  "Flutter-Web",
  "GetX",
  "Http",
  "Dio",
  "React.js",
  "React Native",
  "Expo",
  "Redux",
  "Redux-Thunk",
  "Vue.js",
  "Next.js",
  "Pinia",
  "JQuery",
  "EJS",
  "HTML",
  "CSS",
  "Axios",
  "Ajax",
  "Tailwind",
  "Bootstrap",
  "Vite",
  "JWT",
  "Next.js",

  // Back-End
  "Sqflite",
  "Laravel",
  "Composer",
  "Node.js",
  "Express.js",
  "Sequelize",
  "PostgreSQL",
  "GraphQL",
  "Docker",
  "MongoDB",
  "Redis",
  "JSON Web Tokens",
  "Apollo",
  "Unit Testing",
  "REST API",
  "ERPNext",
  "Frappe",

  // Others
  "n8n",
  "ChatGPT",
  "Gemini",
  "GitHub Copilot",
  "Google Cloud",
  "Niagahoster",
  "Vercel",
  "GitHub",
  "Amazon Web Services S3",
  "Amazon Web Services EC2",
  "Firebase",
  "Netlify",
  "Railway",
  "OAuth",
  "Midtrans",
  "ESLint",
  "Prettier",
  "VS Code",
  "Android Studio",
  "LLM",
  "Cursor",
  "IDX"
];

    const options = {
      radius: radius,
      itemClass: "item",
    };

    TagCloud(container, texts, options);
    document.querySelector(".tagcloud").style.margin = "auto";
  },
};
</script>

<style lang="scss" scoped>
.global {
  margin: 0 auto;
  font-weight: 600;
  // color: #00f2ea;
  font-family: "Poppins", sans-serif;
  user-select: none;
}

@media only screen and (max-width: 1024px) {
  .global {
    display: block;
  }
}

@media only screen and (max-width: 600px) {
  .global {
    position: relative;
    font-weight: 500;
    font-size: 1rem;
    transform: translateX(-24px);
    overflow-x: hidden;
   
  }
}
</style>
